import { render, staticRenderFns } from "./addDriverDoc.vue?vue&type=template&id=50a5a26c&scoped=true&"
import script from "./addDriverDoc.vue?vue&type=script&lang=js&"
export * from "./addDriverDoc.vue?vue&type=script&lang=js&"
import style0 from "./addDriverDoc.vue?vue&type=style&index=0&id=50a5a26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5a26c",
  null
  
)

export default component.exports